export const TABLE_ROUTING:any = {
    "accounting_book" : "/acc-books",
    "accounting_class" : "/acc-classes",
    "api_route_permission": "",
    "api_routes": "",
    "app_menus": "",
    "app_modules" : "",
    "applications" : "/applications",
    "assets" : "/assets", 
    "available_languages" : "/available-languages",
    "cash_accounts" : "/cash-accs",
    "cash_note_details": "/cash-note-details",
    "cash_note" : "/cash-notes",
    "cash_transfer_details" : "/cash-transfers-detail",
    "cash_transfer": "/cash-transfers",
    "categories" : "/categories",
    "chart_of_account" : "/chart-of-accs", 
    "coa_transaction_detail": "",
    "coa_transaction_summary": "",
    "company" : "/companies",
    "contact": "/contacts",
    "cost_histories": "/cost-histories",
    "currency_exchange_rate_his": "/currency-exchange-history",
    "currency_exchange_rate": "/currency-exchanges",
    "currency_sheets" : "/currency-sheets",
    "customer_reservation": "/reserve-tables",
    "floor_table" : "/floor-tables",
    "general_ledger_details": "/gl-details",
    "general_ledger" : "/gls",
    "gl_acc_mapping" : "/gl-acc-mappings",
    "global_picklist": "/global-picklists",
    "inv_adj_detail" : "/inv-adj-details",
    "inv_adjustment": "/inv-adjs",
    "invoice_details": "/invoice-details",
    "invoice_receipt" : "/invoices-receipts",
    "invoices" : "/invoices",
    "issue_product_detail" : "/issue-prod-details",
    "issue_product" : "/issue-prods",
    "kit_assembly_detail" : "/kit-assembly-details",
    "kit_assembly": "/kit-assemblies",
    "kit_spec_details": "/kit-spec-details",
    "kit_specification" : "/kit-specs",
    "location_area" : "/location-areas",
    "login_histories" : "/login-histories",
    "metadata_config": "/metadatas",
    "payment_methods" : "/payment-methods",
    "person_account" : "/people",
    "photos" : "/photos",
    "physical_count_detail": "/physical-count-details",
    "physical_count" : "/physical-counts",
    "po_details" : "/purchase-order-detail",
    
    "pos_permission": "/pos-permissions",
    "posts" : "/posts", 
    "pr_details": "/purchase-receipt-details",
    "pricebook_entry" : "/pricebook-entries",
    "pricebook" : "/pricebooks", 
    "printed_invoice_history": "",
    "product_cost_status": "/product-std-costs",
    "product_properties": "/product-properties",
    "product_uoms" : "/prod-uoms",
    "product_warehouse_details" : "/prod-warehouse-details",
    "products" : "/products",
    "profile_permission": "/profile-permissions",
    "profiles": "/profiles",
    "properties" : "/properties",
    "purchase_bill_details" : "/purchase-bill-detail",
    "purchase_bill_payments" : "/purchase-bill-payment",
    "purchase_bills" : "/purchase-bill",
    "purchase_orders" : "/purchase-orders",
    "purchase_payments": "/purchase-payment",
    "purchase_receipts" : "/purchase-receipt",
    "receipt_product_detail" : "/receipt-prod-details",
    "receipt_product" : "/receipt-prods",
    "receipts" : "/receipts",
    "record_type" : "/recordtypes",
    "report_sale_detail" : "/report-sale-detail",
    "report_sale_summary" : "/report-sale-summary",
    "sale_order_details" : "/sale-order-details",
    "sale_order" : "/sale-orders",
    "sale_transaction_count" : "/sale-transaction-counts",
    "saleorder_prepayment" : "/so-prepayments",
    "sections" : "/sections", 
    "setup_steps" : "/init-setup",
    "shipment_details" : "/shipment-details",
    "shipments" : "/shipments",
    "shop_currency" : "/currencies",
    "site_nav" : "/site-navs",
    "site_pages" : "/site-pages",
    "staff_end_day" : "/staff-end-days",
    "staff_shifts": "/staff-shifts",
    "theory_collection" : "/theory-collections",
    "transfer_product_detail" : "/transfer-prod-details",
    "transfer_product" : "/transfer-prods",
    "uom_master" : "/uoms",
    "user_roles" : "/user-roles",
    "users" : "/users",
    "warehouse_locations": "/warehouse-locations",
    "warehouses": "/warehouses", 
    
    // Import route api public 
    "PublicCompany" : "/public-company",
    "PublicSiteNav" : "/theme-menu",
    "PublicProducts" : "/public-products",
    "PublicCategories" : "/public-categories",
    "PublicRecordtype" : "/public-recordtype",
    "PublicPosts" : "/public-articles",
    "ThemePage" : "/theme-page", // extends SitePage 
};
